const MEDIA_TYPES = ['image', 'video', 'audio'];

const isRemoteUri = (uri) => {
   if (typeof uri !== 'string' || uri.trim() === '') return false;
   const normalized = uri.trim().toLowerCase();
   return normalized.startsWith('http:') || normalized.startsWith('https:');
};

const matchesMediaType = (media, mediaType) => {
   if (!MEDIA_TYPES.includes(mediaType)) return false;
   const mimeType = media && (media.mimeType || media.mime_type);
   return typeof mimeType === 'string' && mimeType.trim().toLowerCase().startsWith(`${mediaType}/`);
};

const resolveMessageMediaUri = ({ message = {}, mediaType }) => {
   const media = message.media || {};
   const remoteUri = media.remoteUri || media.remote_uri;

   if (matchesMediaType(media, mediaType) && isRemoteUri(remoteUri)) {
      return remoteUri;
   }

   const typedUri = message[mediaType];
   return isRemoteUri(typedUri) ? typedUri : null;
};

export { isRemoteUri, resolveMessageMediaUri };
